import EventStack from './EventStack';
var instance = new EventStack();
export default instance;